/*
 * Shipping rate calculator for the Flex ajax cart drawer.
 *
 * /cart/shipping_rates.json will not accept a ZIP on its own. Without country
 * it answers {"country":["Select a country/region"]}, and with country but no
 * province it answers {"province":["Select a state"]}. This file always sends
 * country, province and zip.
 *
 * The customer only sees a ZIP field. Country is fixed to the store's shipping
 * country, and the state is resolved from the ZIP by assets/us-zip-state.js,
 * which must load before this file. If a ZIP cannot be resolved, or resolves to
 * a state the store does not list, the state select is revealed so the customer
 * can pick one instead of hitting a dead end.
 *
 * Server messages are shown verbatim rather than replaced with a generic line,
 * so cart level blocks (for example a terms and conditions validation) are
 * visible instead of looking like a broken ZIP.
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-drawer-rate-calculator]';
  var INIT_FLAG = 'drawerRateCalculatorReady';

  /* Values survive a drawer re-render so the customer does not retype them. */
  var lastAddress = { country: '', province: '', zip: '' };

  function el(root, name) {
    return root.querySelector('[data-drawer-rate-' + name + ']');
  }

  function formatPrice(price) {
    var currency = (window.PXUTheme && window.PXUTheme.currency) || {};
    var symbol = currency.symbol || '$';
    var output = symbol + price;

    if (currency.display_format === 'money_with_currency_format' && currency.iso_code) {
      output = output + ' ' + currency.iso_code;
    }

    return '<span class="money">' + output + '</span>';
  }

  function countryData(countryName) {
    if (!window.Countries) {
      return null;
    }
    return window.Countries[countryName] || null;
  }

  function readProvinces(countrySelect) {
    var option = countrySelect.options[countrySelect.selectedIndex];
    var raw;

    if (!option) {
      return [];
    }

    raw = option.getAttribute('data-provinces');

    if (!raw) {
      return [];
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      return [];
    }
  }

  function selectCountry(root, countrySelect) {
    var wanted = lastAddress.country || root.getAttribute('data-default-country') || '';
    var index;

    if (wanted) {
      for (index = 0; index < countrySelect.options.length; index += 1) {
        if (countrySelect.options[index].value === wanted) {
          countrySelect.selectedIndex = index;
          lastAddress.country = wanted;
          return;
        }
      }
    }

    if (countrySelect.options.length) {
      countrySelect.selectedIndex = 0;
      lastAddress.country = countrySelect.options[0].value;
    }
  }

  function buildProvinces(root, preselect) {
    var countrySelect = el(root, 'country');
    var provinceSelect = el(root, 'province');
    var provinceField = el(root, 'province-field');
    var provinceLabel = el(root, 'province-label');
    var zipInput = el(root, 'zip');
    var provinces = readProvinces(countrySelect);
    var data = countryData(countrySelect.value);
    var index;
    var option;

    provinceSelect.innerHTML = '';

    for (index = 0; index < provinces.length; index += 1) {
      option = document.createElement('option');
      option.value = provinces[index][0];
      option.textContent = provinces[index][1];
      provinceSelect.appendChild(option);
    }

    /* The field stays hidden. It is only revealed when the ZIP cannot be resolved. */
    provinceField.setAttribute('hidden', 'hidden');

    if (provinces.length && preselect) {
      provinceSelect.value = preselect;
    }

    lastAddress.province = provinces.length ? provinceSelect.value : '';

    if (data) {
      if (data.province_label && provinceLabel) {
        provinceLabel.textContent = data.province_label;
        provinceSelect.setAttribute('aria-label', data.province_label);
      }
      if (data.zip_label && zipInput) {
        zipInput.setAttribute('aria-label', data.zip_label);
        zipInput.setAttribute('placeholder', 'Enter ' + data.zip_label.toLowerCase());
      }
    }
  }

  function normalise(value) {
    return String(value || '').toLowerCase().replace(/[^a-z]/g, '');
  }

  /*
   * country_option_tags gives province options whose value is the province name,
   * so a state code is matched against both the option value and its label.
   */
  function findProvinceOption(provinceSelect, code) {
    var lookup = window.LobsterBoysZipState;
    var name = lookup ? lookup.stateName(code) : '';
    var wantedCode = normalise(code);
    var wantedName = normalise(name);
    var option;
    var index;

    for (index = 0; index < provinceSelect.options.length; index += 1) {
      option = provinceSelect.options[index];

      if (normalise(option.value) === wantedCode || normalise(option.textContent) === wantedCode) {
        return option.value;
      }

      if (wantedName && (normalise(option.value) === wantedName || normalise(option.textContent) === wantedName)) {
        return option.value;
      }
    }

    return '';
  }

  function revealProvinceField(root) {
    el(root, 'province-field').removeAttribute('hidden');
  }

  function clearResponse(root) {
    var response = el(root, 'response');

    response.setAttribute('hidden', 'hidden');
    response.classList.remove('drawer-rate-calculator__response--error');
    el(root, 'message').innerHTML = '';
    el(root, 'rates').innerHTML = '';
  }

  function showMessage(root, text, isError) {
    var response = el(root, 'response');

    response.removeAttribute('hidden');
    el(root, 'message').textContent = text;

    if (isError) {
      response.classList.add('drawer-rate-calculator__response--error');
    } else {
      response.classList.remove('drawer-rate-calculator__response--error');
    }
  }

  function showRates(root, shippingRates) {
    var rates = el(root, 'rates');
    var index;
    var item;

    rates.innerHTML = '';

    if (!shippingRates.length) {
      showMessage(root, 'No shipping rates are available for this address.', true);
      return;
    }

    showMessage(
      root,
      shippingRates.length === 1 ? 'One rate available' : shippingRates.length + ' rates available',
      false
    );

    for (index = 0; index < shippingRates.length; index += 1) {
      item = document.createElement('li');
      item.className = 'drawer-rate-calculator__rate';
      item.innerHTML =
        '<span class="drawer-rate-calculator__rate-name"></span>' +
        '<span class="drawer-rate-calculator__rate-price">' + formatPrice(shippingRates[index].price) + '</span>';
      item.firstChild.textContent = shippingRates[index].presentment_name || shippingRates[index].name;
      rates.appendChild(item);
    }
  }

  /*
   * The endpoint answers with either {"errors": "message"} or a field map such
   * as {"province": ["Select a state"]}. Both shapes are surfaced as written.
   */
  function errorText(payload) {
    var messages = [];
    var key;

    if (!payload) {
      return 'We could not calculate shipping right now. Please try again.';
    }

    if (typeof payload === 'string') {
      return payload;
    }

    if (typeof payload.errors === 'string') {
      return payload.errors;
    }

    var source = payload.errors && typeof payload.errors === 'object' ? payload.errors : payload;

    for (key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        messages.push([].concat(source[key]).join(', '));
      }
    }

    return messages.length ? messages.join('. ') : 'We could not calculate shipping right now. Please try again.';
  }

  function getRates(root) {
    var countrySelect = el(root, 'country');
    var provinceSelect = el(root, 'province');
    var provinceField = el(root, 'province-field');
    var zipInput = el(root, 'zip');
    var submit = el(root, 'submit');
    var cartUrl = (window.PXUTheme && window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
    var lookup = window.LobsterBoysZipState;
    var digits = String(zipInput.value || '').replace(/[^0-9]/g, '');
    var province = '';
    var address;
    var query = [];
    var key;
    var code;

    if (digits.length < 5) {
      showMessage(root, 'Please enter a 5 digit ZIP code.', true);
      return;
    }

    if (provinceField.hasAttribute('hidden')) {
      code = lookup ? lookup.stateCode(digits) : '';
      province = code ? findProvinceOption(provinceSelect, code) : '';

      if (!province) {
        revealProvinceField(root);
        showMessage(root, 'We could not match that ZIP code to a state. Please choose your state.', true);
        return;
      }

      provinceSelect.value = province;
    } else {
      province = provinceSelect.value;
    }

    address = {
      country: countrySelect.value,
      province: province,
      zip: zipInput.value
    };

    for (key in address) {
      if (Object.prototype.hasOwnProperty.call(address, key)) {
        query.push('shipping_address[' + encodeURIComponent(key) + ']=' + encodeURIComponent(address[key]));
      }
    }

    lastAddress.country = address.country;
    lastAddress.province = address.province;
    lastAddress.zip = address.zip;

    submit.setAttribute('disabled', 'disabled');
    submit.classList.add('is-loading');
    clearResponse(root);

    fetch(cartUrl + '/shipping_rates.json?' + query.join('&'), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          return { ok: response.ok, payload: payload };
        });
      })
      .then(function (result) {
        if (result.ok && result.payload && result.payload.shipping_rates) {
          showRates(root, result.payload.shipping_rates);
        } else {
          showMessage(root, errorText(result.payload), true);
        }
      })
      .catch(function () {
        showMessage(root, 'We could not calculate shipping right now. Please try again.', true);
      })
      .then(function () {
        submit.removeAttribute('disabled');
        submit.classList.remove('is-loading');
      });
  }

  function initRoot(root) {
    var countrySelect;
    var provinceSelect;
    var zipInput;

    if (!root || root[INIT_FLAG]) {
      return;
    }

    root[INIT_FLAG] = true;

    countrySelect = el(root, 'country');
    provinceSelect = el(root, 'province');
    zipInput = el(root, 'zip');

    if (!countrySelect || !provinceSelect || !zipInput) {
      return;
    }

    selectCountry(root, countrySelect);
    buildProvinces(root, lastAddress.province);

    if (lastAddress.zip) {
      zipInput.value = lastAddress.zip;
    }

    countrySelect.addEventListener('change', function () {
      lastAddress.country = countrySelect.value;
      buildProvinces(root, '');
      clearResponse(root);
    });

    provinceSelect.addEventListener('change', function () {
      lastAddress.province = provinceSelect.value;
      clearResponse(root);
    });

    zipInput.addEventListener('input', function () {
      lastAddress.zip = zipInput.value;
      el(root, 'province-field').setAttribute('hidden', 'hidden');
    });

    zipInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.keyCode === 13) {
        event.preventDefault();
        getRates(root);
      }
    });

    el(root, 'submit').addEventListener('click', function (event) {
      event.preventDefault();
      getRates(root);
    });
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    var index;

    for (index = 0; index < roots.length; index += 1) {
      initRoot(roots[index]);
    }
  }

  function watchDrawers() {
    var drawers = document.querySelectorAll('.theme-ajax-cart');
    var timer = null;
    var observer;
    var index;

    if (!drawers.length || typeof MutationObserver === 'undefined') {
      return;
    }

    observer = new MutationObserver(function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(initAll, 50);
    });

    for (index = 0; index < drawers.length; index += 1) {
      observer.observe(drawers[index], { childList: true, subtree: true });
    }
  }

  function boot() {
    initAll();
    watchDrawers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
